import Cover from './pages/Cover';
import Intro from './pages/Intro';
import Closing from './pages/Closing';
import EditorialChapter from './pages/EditorialChapter';
import { editorial } from './editorial/editorialData';

export const CHAPTER_ENTRIES = editorial.chapters.map((chapter) => ({
  key: chapter.key,
  label: chapter.label,
  title: chapter.title,
  Component: EditorialChapter,
}));

export const CHAPTER_PAGE_NAMES = CHAPTER_ENTRIES.map((entry) => entry.key);

export const PAGES = [
  { name: 'cover', Component: Cover },
  { name: 'intro', Component: Intro },
  ...CHAPTER_ENTRIES.map(({ key, Component }) => ({ name: key, Component })),
  { name: 'closing', Component: Closing },
];
